import { Stack } from '@mui/material';

import { Drawer, Spinner, theme, Typography } from '@/shared/design-system';

export const CreatingStep = () => (
  <Drawer open showClose={false} maxWidth={600}>
    <Stack flexDirection="column" alignItems="center" justifyContent="center" flex={1} gap="16px">
      <Spinner />
      <Typography variant="body3" color={theme.colors.white[60]}>
        Saving contact…
      </Typography>
    </Stack>
  </Drawer>
);
